import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import TextInput from 'components/Inputs/TextInput/TextInput';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';
import ErrorsUtils from 'utils/Errors';
import localeUtils from 'utils/LanguageLocale';

const { COUNTRIES } = localeUtils;
const postalCodeLength = FormValidator.FIELD_LENGTHS.postalCode;
const zipCodeLength = FormValidator.FIELD_LENGTHS.zipCode;

function PostalCodeField({
    postalCode = '',
    country = '',
    isInternational = false,
    isAdsRestricted = false,
    zipCodeInvalid = false,
    cityStateZipInvalid = false,
    isFCFinalReleaseEnabled = false,
    isSubscription = false,
    modalTitle = '',
    localization = {},
    onChange,
    onKeyDown,
    zipCodeInputRef,
    fireFormErrorAnalytics
}) {
    const { postalCode: postalCodeLabel, zipPostalCode } = localization;
    const isUS = country ? country === COUNTRIES.US : localeUtils.isUS();
    const isCanada = country === COUNTRIES.CA;

    const maxLengthVal = isAdsRestricted
        ? FormValidator.FIELD_LENGTHS.zipCodeAdsRestricted
        : isInternational
            ? null
            : isCanada
                ? postalCodeLength
                : zipCodeLength;

    const validatePostalCode = zipCode => {
        if (FormValidator.isEmpty(zipCode)) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(
                    modalTitle,
                    isUS
                        ? ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.ZIP_CODE_US)
                        : ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.ZIP_CODE_NON_US)
                );
            }

            return isUS ? ErrorConstants.ERROR_CODES.ZIP_CODE_US : ErrorConstants.ERROR_CODES.ZIP_CODE_NON_US;
        }

        if ((!isInternational && !FormValidator.isValidZipCode(zipCode, isUS ? 'US' : 'CA')) || zipCodeInvalid) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.INVALID_ZIP_CODE));
            }

            return ErrorConstants.ERROR_CODES.INVALID_ZIP_CODE;
        }

        if (isAdsRestricted && !FormValidator.isValidLength(zipCode, 1, maxLengthVal)) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.ZIPCODE_ADS_LONG));
            }

            return ErrorConstants.ERROR_CODES.ZIPCODE_ADS_LONG;
        }

        return null;
    };

    return (
        <TextInput
            name='postalCode'
            autoComplete='postal-code'
            autoCorrect='off'
            isUS={isUS}
            type='text'
            inputMode={isInternational || isCanada ? 'text' : 'numeric'}
            label={isInternational || isCanada ? postalCodeLabel : zipPostalCode}
            required={true}
            maxLength={maxLengthVal}
            hideAsterisk={isUS || isFCFinalReleaseEnabled}
            value={postalCode}
            invalid={zipCodeInvalid || cityStateZipInvalid}
            onChange={onChange}
            onKeyDown={isUS && onKeyDown}
            ref={zipCodeInputRef}
            validateError={validatePostalCode}
            message={zipCodeInvalid || cityStateZipInvalid ? zipCodeInvalid || cityStateZipInvalid : null}
            data-at={Sephora.debug.dataAt('zip_postal_code_input')}
            dataAtError={Sephora.debug.dataAt('zip_code_required_error')}
        />
    );
}

export default wrapFunctionalComponent(PostalCodeField, 'PostalCodeField');
